<template>
  <div class="conference-search-item">
    <div>
      <conference-images></conference-images>
      <search-box class="mb-5"></search-box>
      <booking-status :value="1" class="booking-status mb-5"></booking-status>
    </div>
    <div>
      <booking-search-list
        :booking-search-list-by-date="conferenceSearchListByDate"
        class="booking-search-list"
      ></booking-search-list>
    </div>
  </div>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies"
import SearchBox from "../components/SearchBox"
import ConferenceImages from "../components/ConferenceImages"
import BookingStatus from "../components/BookingStatus"
import BookingSearchList from "../components/BookingSearchList"

export default {
  components: {
    "search-box": SearchBox,
    "conference-images": ConferenceImages,
    "booking-status": BookingStatus,
    "booking-search-list": BookingSearchList,
  },
  data() {
    return {
      conferenceSearchListByDate: [],
    }
  },
  watch: {
    "$route.query": async function routeQueryWatcher() {
      await this.setupConferenceSearchList()
    },
  },
  created() {
    this.setupConferenceSearchList()
  },
  methods: {
    async setupConferenceSearchList() {
      // เอา query มาจาก component: SearchItem
      // this.$route.query {
      //   room_id,
      //   time_duration,
      //   number_of_people,
      //   date
      // }

      const params = {
        ...this.$route.query,
      }

      this.conferenceSearchListByDate =
        await this.fetchConferenceSearchList(params)
    },
    async fetchConferenceSearchList(params) {
      try {
        return await baanRueJaiClient.others.conference.getConferenceSearchList(
          params,
        )
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err)
        return []
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";

.conference-search-item {
}

.booking-status {
  padding-left: 8%;
  padding-right: 8%;
}

.booking-search-list {
  padding-left: 5%;
  padding-right: 5%;
}
</style>
